<template>
    <!-- <div id="banner">
       <img src="@/assets/1.jpg" />
    
    </div> -->
    <div id="banner" @mouseover="mouseOver" @mouseleave="mouseLeave">
        <img :src="currSrc">
        <ul class="point">
            <li v-for="item in imgList" :key="item.id">
                <a class="circle" @click="changeImg(item.id)" :style="item.id===currId?active:''"></a>
            </li>
        </ul>
    </div>
</template>

<script>
    export default {
        name: 'Banner',
        components: {

        },
        data(){
            return{
                currId: 1,
                timer: null,
                currSrc:"http://119.23.227.216/image/ad1.png",
                active:"background-color: #ff5000;",
                imgList:[
                    {id:1, src:"http://119.23.227.216/image/ad1.png"},
                    {id:2, src:"http://119.23.227.216/image/ad2.png"},
                    // {id:3, src:"http://img.daimg.com/uploads/allimg/220804/3-220P41I444.jpg"}
                ]
            }
        },
        mounted() {
            this.timer = setInterval(this.changeImgRight, 10000)
        },
        // computed: {
        //     getSrc() {

        //     }
        // },
        watch:{
            currId(newValue) {
                this.imgList.forEach(ele => {
                    if(ele.id === newValue) {
                        this.currSrc = ele.src
                    }
                });
            }
        },
        methods:{
            changeImg(val){
                this.currId = val
            },
            changeImgLeft() {
                if(this.currId === 1) {
                    this.currId = 3
                } else {
                    this.currId--
                }
            },
            changeImgRight() {
                if(this.currId === 3) {
                    this.currId = 1
                } else {
                    this.currId++
                }
            },
            mouseOver() {
                clearInterval(this.timer)
            },
            mouseLeave() {
                this.timer = setInterval(this.changeImgRight, 10000)
            }
        }


    }
</script>

<style>


    #banner {
        position: relative;
        height: 192px; width: 900px; margin: 0 auto;
        background-color:yellowgreen;
        border-radius: 10px;
    }
    #banner img {
        width: 100%;
        height: 100%;
    }
    #banner .point {
        position: absolute;
        z-index: 999;
        left: 50%;
        bottom: 15px;
        transform: translate(-50%, -50%);
        width: 60px;
        height: 13px;
        border-radius: 8px;
        text-align: center;
        display: flex;
        justify-content: center;
        background-color: #ffffff4d;
    }
    #banner .point li {
        display: inline-flex;
        margin: 3px;
    }
    #banner .point li .circle {
        width: 8px;
        height: 8px;
        border-radius: 8px;
        background-color: rgb(255, 255, 255);
    }
</style>
